import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3a82a008&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3a82a008&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=3a82a008&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a82a008",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a82a008')) {
      api.createRecord('3a82a008', component.options)
    } else {
      api.reload('3a82a008', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3a82a008&scoped=true", function () {
      api.rerender('3a82a008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/businessflowWitness/index.vue"
export default component.exports